import React from 'react';
import { ChannelCustomizedIcon, ExtendedHomepageMainNavItems, IHomepageMainNavItems, NavMainItems } from 'types/working-model';
import Icon, { ICONS } from '@general-ui/icon';

export const getBaseNavIcon = (name: NavMainItems | string, size = 24): React.ReactElement | undefined => {
	switch (name) {
		case NavMainItems.Home:
			return React.createElement(Icon, { name: ICONS.HOME, color: '', size });
		case NavMainItems.Sessions:
		case NavMainItems.Session:
			return React.createElement(Icon, { name: ICONS.TV_WATCH, color: '', size });
		case NavMainItems.Directory:
		case NavMainItems.People:
			return React.createElement(Icon, { name: ICONS.PEOPLE_NAV, color: '', size });
		case NavMainItems.Leaderboard:
			return React.createElement(Icon, { name: ICONS.LEADERBOARD_NAV, color: '', size });
		case 'Logout':
			return React.createElement(Icon, { name: ICONS.LOG_OUT, color: '', size });
	}
};

export const getCustomNavIcon = (icons: ChannelCustomizedIcon[] | undefined, navItem: IHomepageMainNavItems | ExtendedHomepageMainNavItems): React.ReactElement | undefined => {
	const customIcon = icons?.find(icon => icon.uuid === navItem.custom_icon_uuid);

	if (customIcon) {
		return React.createElement('img', { src: customIcon.url, alt: navItem.name });
	}

	return getBaseNavIcon(navItem.name);
};

// Re-export component exports from the .tsx file so that imports resolving to this
// .ts module (which takes priority over .tsx in TypeScript's resolution) still work.
export { default } from './navbar-items.tsx';
